
interface ModalProps {
  show: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  screenType?: string;
  hideCloseIcon?: boolean;
}

const Modal: React.FC<ModalProps> = ({ handleClose, show, children,screenType,hideCloseIcon}) => {
  const showHideClassName = show ? 'modal display-block' : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        {!hideCloseIcon && screenType !== "REGISTER" && screenType !== "CHANGE_PASSWORD" && (
          <button onClick={handleClose} className="close_icn">
            <i className="ic-clearclose"></i>
          </button>
        )}
      </section>
    </div>
  );
};

export default Modal;
